import { PositionSetConfig } from "../../components";

export const hockeyFormations: PositionSetConfig[] = [];
